module.exports = __webpack_public_path__ + "img/Student Information.d3dfbaa3.svg";